import { useAppQuery } from '@/helpers/api/query'

import { createInstance } from '@/helpers/api/base'
import { Code } from '@/types/logs'

const GET_CODES_KEY = 'GET_CODES'

export const useGetCodes = () =>
    useAppQuery<Code[]>({
        queryKey: [GET_CODES_KEY],
        queryFn: () =>
            createInstance({
                url: '/codes',
                method: 'GET',
            }),
        staleTime: Infinity,
    })
